import "./StaffStudentToggle.css";

export default function StaffStudentToggle({
                                               value,
                                               onChange,
                                               onAdd,
                                               roles
                                           }) {
    return (
        <div className="toggle-wrapper">
            <button
                className="add-btn"
                onClick={onAdd}
            >
                +
            </button>

            <div className="toggle">
                {roles.map((role) => (
                    <button
                        key={role.id}
                        className={value === role.id ? "active" : ""}
                        onClick={() => onChange(role.id)}
                    >
                        {role.name}
                    </button>
                ))}

                <button
                    className={value === "all" ? "active" : ""}
                    onClick={() => onChange("all")}
                >
                    All
                </button>
            </div>
        </div>
    );
}
